import { ACTIVITIES_MODULE } from 'Activities/constants/variables'
import { ALERTS_OF_VULNERABILITY_MODULE } from 'AlertsOfVulnerability/constants/variables'
import { CITIZEN_PROFILE_MODULE } from 'CitizenProfile/constants/variables'
import { INSTITUTIONAL_MANAGEMENT_MODULE } from 'InstitutionalManagement/constants/variables'
import { SERVICES_LETTER_MODULE } from 'ServicesLetter/constants/variables'
import { ATTENDANCES_MODULE } from 'Attendances/constants/variables'
import { DATA_INTEGRATOR_MODULE } from 'DataIntegrator/constants/variables'
import { GEO_MODULE } from 'Geo/constants/variables'
import { REGULATION_MODULE } from 'Regulation/constants/variables'
import { DIGITAL_ARCHIVE_MODULE } from 'DigitalArchive/constants/variables'
import { INVENTORY_MODULE } from 'Inventory/constants/variables'
import { SCHEDULES_MODULE } from 'Schedules/constants/variables'
import { OBSERVATORY_MODULE } from 'Observatory/constants/variables'
import { ImpactModule } from 'types'
import { PROCESSES_AND_DOCUMENTS_MODULE } from 'ProcessesAndDocuments/constants/variables'
import { SOCIAL_MANAGER_MODULE } from 'SocialManager/constants/variables'
import { ASSESSMENTS_AND_RESEARCH_MODULE } from 'AssessmentsAndResearch/constants/variables'

type AllImpactModules = {
  [key: string]: ImpactModule
}

export function getModuleByPathOnURL(moduleOnPath: string): ImpactModule {
  const allImpactModules: AllImpactModules = {
    'processos-e-documentos': PROCESSES_AND_DOCUMENTS_MODULE,
    'avaliacoes-e-pesquisas': ASSESSMENTS_AND_RESEARCH_MODULE,
    'app-cidadao': INSTITUTIONAL_MANAGEMENT_MODULE,
    'gestor-social': SOCIAL_MANAGER_MODULE,
    'gestao-institucional': INSTITUTIONAL_MANAGEMENT_MODULE,
    'perfil-cidadao': CITIZEN_PROFILE_MODULE,
    'alertas-de-vulnerabilidade': ALERTS_OF_VULNERABILITY_MODULE,
    'carta-de-servicos': SERVICES_LETTER_MODULE,
    'integrador-de-dados': DATA_INTEGRATOR_MODULE,
    'acervo-digital': DIGITAL_ARCHIVE_MODULE,
    agendas: SCHEDULES_MODULE,
    atividades: ACTIVITIES_MODULE,
    atendimentos: ATTENDANCES_MODULE,
    'atendimento-colaborador': ATTENDANCES_MODULE,
    regulacao: REGULATION_MODULE,
    geo: GEO_MODULE,
    estoque: INVENTORY_MODULE,
    mensageiro: INSTITUTIONAL_MANAGEMENT_MODULE,
    observatorio: OBSERVATORY_MODULE,
    // Playground
    playground: INSTITUTIONAL_MANAGEMENT_MODULE,
  }

  return allImpactModules[moduleOnPath]
}
